import i18n from '@/i18n'
import SystemNotificationList from './notification/list.vue'
import SystemNotificationEdit from './notification/editor.vue'
import SystemNotificationLayoutEdit from './layoutTemplate/editor.vue'
import SystemNotificationLayoutList from './layoutTemplate/list.vue'
import BlankLayout from '../../layout/blankLayout.vue'
import Layout from '../../companyAdmin/layout.vue'
import Index from './index.vue'

const basePath = '/v-admin/system-notification-template-management'
const i18nPrefix = 'admin.company.notification'

const systemNotificationEditRoute = {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: BlankLayout,
  meta: {
    titleI18nKey: `${i18nPrefix}.title.messageManagement`,
    breadcrumb: { labelI18nKey: `${i18nPrefix}.title.messageManagement` }
  },
  children: [
    {
      path: `${basePath}/edit/:templateId`,
      component: SystemNotificationEdit,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.notificationEdit`,
        isEditMode: true
      }
    },
    {
      path: `${basePath}/view/:templateId`,
      component: SystemNotificationEdit,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.notificationView`,
        isViewMode: true
      }
    },
    {
      path: `${basePath}/add`,
      component: SystemNotificationEdit,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.notificationAdd`
      }
    }
  ]
}

const systemNotificationLayoutEditRoute = {
  path: `${basePath}/layout`,
  redirect: `${basePath}/layout/list`,
  component: BlankLayout,
  meta: {
    titleI18nKey: `${i18nPrefix}.title.layoutTemplateManagement`,
    breadcrumb: { labelI18nKey: `${i18nPrefix}.title.layoutTemplateManagement` }
  },
  children: [
    {
      path: `${basePath}/layout/edit/:layoutTemplateId`,
      component: SystemNotificationLayoutEdit,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.layoutEdit`,
        isEditMode: true
      }
    },
    {
      path: `${basePath}/layout/view/:layoutTemplateId`,
      component: SystemNotificationLayoutEdit,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.layoutView`,
        isViewMode: true
      }
    },
    {
      path: `${basePath}/layout/add`,
      component: SystemNotificationLayoutEdit,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.layoutAdd`,
        isEditMode: false
      }
    }
  ]
}

export const tabMenuRoute = {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Index,
  meta: {
    titleI18nKey: `${i18nPrefix}.title.management`,
    breadcrumb: { hidden: true }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: SystemNotificationList,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.messageManagement`,
        tabMenuLabelI18nKey: `${i18nPrefix}.title.messageManagement`,
        breadcrumb: { labelI18nKey: `${i18nPrefix}.title.messageManagement` }
      }
    },
    {
      path: `${basePath}/layout/list`,
      component: SystemNotificationLayoutList,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.layoutTemplateManagement`,
        tabMenuLabelI18nKey: `${i18nPrefix}.title.layoutTemplateManagement`,
        breadcrumb: { labelI18nKey: `${i18nPrefix}.title.layoutTemplateManagement` }
      }
    }
  ]
}

export default {
  path: `${basePath}`,
  component: Layout,
  meta: {
    permission: 'PERM_SYSTEM_NOTIFICATION_TEMPLATE_MANAGEMENT',
    isAllInclude: true,
    isNewPage: true,
    titleI18nKey: `${i18nPrefix}.title.messageManagement`,
    menu: {
      get label () {
        return i18n.t(`${i18nPrefix}.title.messageManagement`)
      }
    }
  },
  children: [
    tabMenuRoute,
    systemNotificationEditRoute,
    systemNotificationLayoutEditRoute
  ]
}
